/* Kindly v2 — header: mobiele navigatie open- en dichtklappen. */
(function () {
  'use strict';

  function init(header) {
    if (header.__kv2Chrome) return;
    header.__kv2Chrome = true;

    var burger = header.querySelector('[data-kv2-burger]');
    if (!burger) return;

    function setOpen(open) {
      header.setAttribute('data-open', open ? 'true' : 'false');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    burger.addEventListener('click', function () {
      setOpen(header.getAttribute('data-open') !== 'true');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    // Buiten de header klikken sluit het menu.
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) setOpen(false);
    });
  }

  function boot() {
    document.querySelectorAll('[data-kv2-header]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

/* Kindly v2 — land- en taalwisselaar: kiezen schakelt direct door, één paneel
   tegelijk open, klik buiten het paneel of Escape sluit het. */
(function () {
  'use strict';

  function init(box) {
    if (box.__kv2Locale) return;
    box.__kv2Locale = true;
    box.classList.add('is-js');

    var form = box.querySelector('[data-kv2-locale-form]');
    var combo = box.querySelector('[data-kv2-locale-combo]');
    if (combo) {
      combo.addEventListener('change', function () {
        var parts = combo.value.split('|');
        form.querySelector('[data-kv2-locale-country]').value = parts[0];
        form.querySelector('[data-kv2-locale-language]').value = parts[1] || form.querySelector('[data-kv2-locale-language]').value;
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }

    box.addEventListener('toggle', function () {
      if (!box.open) return;
      document.querySelectorAll('[data-kv2-locale][open]').forEach(function (other) {
        if (other !== box) other.removeAttribute('open');
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-kv2-locale]').forEach(init);
  }

  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-kv2-locale][open]').forEach(function (box) {
      if (!box.contains(e.target)) box.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-kv2-locale][open]').forEach(function (box) { box.removeAttribute('open'); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
